<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-container>
            <v-toolbar dense class="mb-2 indigo white--text" flat>
                <v-row align="center">
                    <v-col>
                        <v-toolbar-title>Notes</v-toolbar-title>
                    </v-col>
                    <v-col md="2">
                        <v-btn color="primary" :disabled="!needToSave" @click="saveNote()">Save Note</v-btn>
                    </v-col>
                </v-row>
            </v-toolbar>
            <v-progress-linear v-if="waitingLocal" :indeterminate="true"/>
            <v-textarea
                    v-model="items[0].notes"
                    @input="noteChanged()"
                    placeholder="Enter your test notes here."
                    outlined
                    single-line
                    auto-grow/>
            <v-card>
                <v-card-title>
                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Notes History</span>
                </v-card-title>
                <v-card-text>
                    <span v-html="items[0].notesHistoryFormatted"></span>
                </v-card-text>
            </v-card>
            <v-toolbar dense class="mt-2 indigo" flat>
                <v-row justify="end">
                    <v-col md="2">
                        <v-btn color="primary" :disabled="!needToSave" @click="saveNote()">Save Note</v-btn>
                    </v-col>
                </v-row>
            </v-toolbar>
        </v-container>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'

    export default
    {
        name: 'test-notes',
        data: function ()
        {
            return {
                waitingLocal: false,
                items:
                [
                    {
                        notes: '',
                        notesHistory: '',
                        notesHistoryFormatted: ''
                    }
                ],
                needToSave: false,
                prevNeedToSave: false
            }
        },
        props:
        {
            mrn: String(''),
            resultData: {},
            resetData: Boolean(false)
        },
        computed:
        {
            ...mapState('auth',
            {
                currentUser: state => state.currentUser
            })
        },
        watch:
        {
            resultData()
            {
                this.resultDataCommon()
            },
            resetData()
            {
                this.resultDataCommon()
            }
        },
        mounted()
        {
            this.resultDataCommon()
        },
        methods:
        {
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            ...mapActions('tests', ['UPSERT_NOTE']),
            resultDataCommon()
            {
                this.items[0].notes = '';
                this.items[0].notesHistory = '';
                this.items[0].notesHistoryFormatted = '';
                this.noteChanged();
                if (this.resultData.patientNote && this.resultData.patientNote.notes)
                {
                    let notes = this.pullOutValues(this.resultData.patientNote.notes, '<<NOTES>>');
                    // If no NOTES tag was found, assume an old style note, and convert now
                    if (0 === notes.length)
                    {
                        notes = this.convertNote(this.resultData.patientNote);
                        this.items[0].notesHistory = notes[0]
                    }
                    else
                    {
                        this.items[0].notesHistory = this.resultData.patientNote.notes
                    }
                    for (const note of this.processNotes(notes))
                    {
                        this.items[0].notesHistoryFormatted += `<h4><b>${note.updatedOnString}${note.displayName}</h4></b><p>${note.notes.replace('\n', '<br>')}</p>`
                    }
                }
                else
                {
                    this.items[0].notesHistory = '';
                    this.items[0].notesHistoryFormatted = ''
                }
            },
            noteChanged()
            {
                this.needToSave = this.items[0].notes !== '';
                if (this.prevNeedToSave !== this.needToSave)
                {
                    this.prevNeedToSave = this.needToSave;
                    this.$emit('note-changed', this.needToSave)
                }
            },
            convertNote(patientNote)
            {
                let notesArray = [];
                const displayName = `<<BY>> by ${patientNote.displayName !== null ? patientNote.displayName : 'N/A'}\n<<BY>>`;
                const updatedAt = `<<UPDATED>>Updated ${this.notesDateTime(new Date())}<<UPDATED>>`;
                notesArray.push(`<<NOTES>>${updatedAt}${displayName}<<NOTE>>${patientNote.notes}<<NOTE>><<NOTES>>`);
                return notesArray
            },
            processNotes(notes)
            {
                let patientNotes = [];

                for (const note of notes)
                {
                    let patientNote = {};
                    patientNote.updatedOnString = this.pullOutValues(note, '<<UPDATED>>')[0];
                    patientNote.displayName = this.pullOutValues(note, '<<BY>>')[0];
                    patientNote.notes = this.pullOutValues(note, '<<NOTE>>')[0];
                    patientNotes.push(patientNote)
                }
                return patientNotes
            },
            pullOutValues(inValue, searchString)
            {
                let values = inValue.split(searchString);
                let index = 0;
                let processedValues = [];
                for (const value of values)
                {
                    if (0 === index % 2)
                    {
                        index++;
                        continue
                    }
                    processedValues.push(value);
                    index++
                }
                return processedValues
            },
            async saveNote()
            {
                try
                {
                    const updatedOnDate = new Date();
                    const displayName = ` by ${this.currentUser.displayName !== null ? this.currentUser.displayName : 'N/A'}`;
                    let updatedOn = `Updated ${this.notesDateTime(updatedOnDate)}`;
                    const patientNote =
                    {
                        displayName: this.currentUser.displayName,
                        updatedOn: updatedOnDate,
                        notes: `<<NOTES>><<UPDATED>>Updated ${this.notesDateTime(updatedOnDate)}<<UPDATED>><<BY>> by ${this.currentUser.displayName}\n<<BY>><<NOTE>>${this.items[0].notes}<<NOTE>><<NOTES>>${this.items[0].notesHistory}`
                    };
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    this.waitingLocal = true;
                    await this.UPSERT_NOTE({mrn: this.mrn, visitId: this.resultData.visitId, data: patientNote});
                    this.items[0].notesHistoryFormatted = `<h4><b>${updatedOn}${displayName}</h4></b><p>${this.items[0].notes.replace('\n', '<br>')}</p>${this.items[0].notesHistoryFormatted}`
                    this.items[0].notesHistory = patientNote.notes;
                    this.items[0].notes = '';
                    this.needToSave = false;
                    this.prevNeedToSave = false;
                    this.$emit('save-note', {visitId: this.resultData.visitId, patientNote: patientNote})
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message)
                }
                this.WAITING(false);
                this.waitingLocal = false
            },
            notesDateTime(date)
            {
                const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
                const timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit' };
                return `${date.toLocaleDateString(navigator.languages[0], dateOptions)} at ${date.toLocaleTimeString(navigator.languages[0], timeOptions)}`
            }
        }
    };
</script>

<style scoped>
</style>